<script lang="ts">
  import type { GridProps } from './types';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';

  type $$Props = GridProps;

  export let entryId: GridProps['entryId'];
  export let entries: GridProps['entries'];
</script>

<div class="Grid Grid-{entryId} Grid-{entryId}-box-properties" data-entry-id={entryId}>
  <DynamicChildrenComponent children={entries} />
</div>
